import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const UserFilters = ({ filters, onFilterChange, onSearch, onReset }) => {
  const roleOptions = [
    { value: '', label: 'All Roles' },
    { value: 'admin', label: 'Admin' },
    { value: 'analyst', label: 'Analyst' },
    { value: 'merchant', label: 'Merchant' }
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'suspended', label: 'Suspended' }
  ];

  return (
    <div className="bg-white rounded-lg border border-border p-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Input
          placeholder="Search by name or email..."
          onChange={(e) => onSearch(e?.target?.value)}
          className="md:col-span-2"
        />
        <Select
          options={roleOptions}
          value={filters?.role || ''}
          onChange={(value) => onFilterChange({ ...filters, role: value })}
          placeholder="Filter by role"
        />
        <Select
          options={statusOptions}
          value={filters?.status || ''}
          onChange={(value) => onFilterChange({ ...filters, status: value })}
          placeholder="Filter by status"
        />
      </div>
      {(filters?.role || filters?.status) && (
        <div className="mt-4 flex justify-end">
          <Button variant="ghost" size="sm" onClick={onReset}>
            Reset Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default UserFilters;